export const SET_WEBSITE = "SET_WEBSITE";
export const FALSE_WEBSITE = "FALSE_WEBSITE";
